var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('div',{staticClass:"container",style:({ width: _vm.computedWidth })},[_c('div',{staticStyle:{"position":"absolute","top":"30px","right":"30px"}},[_c('LangSelect')],1),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }